module.exports = __webpack_public_path__ + "static/media/scale.d55edcb0.png";